import { TypedEventEmitter } from "@fluidframework/common-utils";
/**
 * Event Emitter helper class
 * Any exceptions thrown by listeners will be caught and raised through "error" event.
 * Any exception thrown by "error" listeners will propagate to the caller.
 */
export class EventEmitterWithErrorHandling extends TypedEventEmitter {
    constructor(errorHandler) {
        super();
        this.errorHandler = errorHandler;
    }
    emit(event, ...args) {
        try {
            return super.emit(event, ...args);
        }
        catch (error) {
            this.errorHandler(event, error);
            return true;
        }
    }
}
//# sourceMappingURL=eventEmitterWithErrorHandling.js.map